import Button from '@components/buttons/button/button.component'
import React, { PropsWithChildren, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import './inside-navigation-parcel.component.scoped.scss'
import './inside-navigation-parcel.component.scss'

interface Props extends PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  footer?: boolean
  homeNavigationPath?: string
  confirmFunction?: any
  disabledButton?: boolean
  loadingButton?: boolean
  showOnlyBackButton?: boolean
}

export default ({
  className = '',
  id = '',
  children,
  title = '',
  footer = true,
  homeNavigationPath = '',
  confirmFunction,
  loadingButton = false,
  disabledButton = false,
  showOnlyBackButton = false,
}: Props) => {
  const [t] = useTranslation('navigationLayout')
  const [height, setHeight] = useState(window?.innerHeight)
  const [width, setWidth] = useState(window?.innerWidth)
  const navigate = useNavigate()

  useEffect(() => {
    const updateHeight = () => {
      setHeight(window?.innerHeight)
    }
    const updateWidth = () => {
      setWidth(window?.innerWidth)
    }
    window.addEventListener('resize', updateHeight)
    window.addEventListener('resize', updateWidth)
    return () => {
      window.removeEventListener('resize', updateHeight)
      window.removeEventListener('resize', updateWidth)
    }
  }, [])

  const onClickButton = (event) => {
    if (!loadingButton && !disabledButton && typeof confirmFunction === 'function') {
      confirmFunction(event)
    }
  }

  const onClickBackButton = (event) => {
    if (!loadingButton && homeNavigationPath) {
      navigate(homeNavigationPath)
    }
  }

  return (
    <div className={`inside-navigation-parcel ${className}`} id={id}>
      {title ? (
        <header>
          <h5>{title}</h5>
          {onClickButton ? (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault()
                onClickBackButton(e)
              }}
              disabled={loadingButton}
              id="cancel-button-navigation-cross"
              className="cancel-button-navigation-cross"
            >
              <i className="fa-regular fa-times"></i>
            </button>
          ) : null}
        </header>
      ) : null}
      <div
        className={`content-inside scrollbar ${!title ? 'no-header' : ''} ${!footer ? 'no-footer ' : ''}`}
        style={{
          height: width < 991 ? (footer ? `calc(${height}px - 50px - 70px + 13px)` : `calc(${height}px - 50px + 13px)`) : null,
        }}
      >
        {children}
      </div>
      {footer ? (
        <footer>
          {homeNavigationPath ? (
            <Button
              onClick={(e) => onClickBackButton(e)}
              disabled={loadingButton}
              id="cancel-button-navigation"
              className="cancel-button-navigation"
              color="transparent"
              textColor="var(--text_color)"
              borderColor="transparent"
            >
              {showOnlyBackButton ? t('back') : t('cancel')}
            </Button>
          ) : null}
          {onClickButton && !showOnlyBackButton ? (
            <Button
              onClick={(e) => onClickButton(e)}
              loading={loadingButton}
              disabled={disabledButton}
              id="save-button-navigation"
              className="save-button-navigation"
            >
              {t('save')}
            </Button>
          ) : null}
        </footer>
      ) : null}
    </div>
  )
}
